$(document).ready(function() {
	if(!document.querySelector('.GPC0013')) return false;

	var $obj=$('.GPC0013');
	
	//change text
	$obj.find('.btn-tech-ctrl').click(function(){
		var $specArea = $(this).parent().next('.tech-spacs-area');
		$specArea.collapse('toggle');
		return false;
	});

	$obj.find('.tech-spacs-wrap').on({
		'show.bs.collapse': function(e){
			var btn = e.delegateTarget.querySelector('.btn-tech-ctrl');
			$(btn).removeClass('collapsed');
			$(btn).text(btn.getAttribute('data-close-title'));
			$(btn).attr('aria-expanded', true);
		},
		'hide.bs.collapse': function(e){
			var btn = e.delegateTarget.querySelector('.btn-tech-ctrl');
			$(btn).addClass('collapsed');
			$(btn).text(btn.getAttribute('data-open-title'));
			$(btn).attr('aria-expanded', false);
		}
	}, '.tech-spacs-area');
	
	var specRunPrint;
	specRunPrint= function(){
		if(!document.querySelector('.page-print') && !document.querySelector('.page-print')) return false;
		var $printPage = $obj.find('.page-print');
		//var p = window.location.protocol;
		//var host = window.location.hostname;
		//var port = window.location.port;
		//var mydomain = p + '//' + host + ((port)? ':'+port : '');
		$printPage.off().on('click', function(e) {
			e.preventDefault();
			// adobe
			adobeTrackEvent('print-spec', {page_event : {print_spec : true}});
			var modal = $(e.currentTarget).parents('.component-wrap').parent().get(0);
			// 20200506 START 이상현 - pdp spec print 화면의 direction 설정
			var direction = ISRTL ? "rtl" : "ltr";
			// 20200506 END
			/* LGEAU-618 start*/
			if(document.querySelector('.GPC0009')&&COUNTRY_CODE.toLowerCase()=='au'){
				var comp9 = $('.GPC0009').parents('.component-wrap').parent().get(0);
			}
			/* LGEAU-618 end*/
			if(modal) {
				//console.log('1');
				var divToPrint=modal;
				// 20200406 START 박지영 - Spec > print 항상 새창으로 뜨도록 수정
				var newWin=window.open('','_blank');
				// 20200406 END
				newWin.document.open();
				// 20200401 START 박지영 : spec 영역 print 버튼 클릭 시 IE에서 잘 안되던 것 수정
				// 20200506 START 이상현 - pdp spec print 화면의 direction 설정
				/* LGEAU-618 start*/
				var title="";
				if(typeof $(comp9).find('.desktop-info .model-title')!=='undefined'){
					title=$(comp9).find('.desktop-info .model-title').text();
				}
				
				if(comp9){
					newWin.document.write('<html dir='+ direction +'><title>'+title+'</title><body><style>@media print{.tech-spacs-area{display:block !important;} .pdp-visual-area.visible-sm{display:none !important;}.pdp-visual-area.hidden-sm{display:block !important;}.GPC0009 .pdp-visual .default{float:right;}}.tech-spacs-area{display:block !important;} .modal, .pdp-layer-tab, .pdp-specs-content, .tech-ctrl-area, .pdp-info .rating-area, .pdp-info .info-top, .pdp-info .relation-area, .pdp-info .delivery-area, .specs-dimensions-area,.pdp-info .dot-text-fixed{display:none !important;}</style><link href="/lg5-common-gp/css/bootstrap.min.css" type="text/css" rel="stylesheet"><link href="/lg5-common-gp/css/fonts.min.css" type="text/css" rel="stylesheet"><link href="/lg5-common-gp/css/default.min.css" type="text/css" rel="stylesheet"><link rel="stylesheet" href="/lg5-common-gp/css/components.min.css" type="text/css" /><link media="all" rel="stylesheet" type="text/css" href="https://apps.bazaarvoice.com/apps/rating_summary/rating_summary-2.48.2.css"><link href="/lg5-common-gp/css/GPC0009.min.css" type="text/css" rel="stylesheet"><link href="/lg5-common-gp/css/GPC0013.min.css" type="text/css" rel="stylesheet"><link rel="stylesheet" href="/lg5-common-gp/css/modal-print.min.css" type="text/css" /><div class="specs-print"><div class="m-2"><img src="/lg5-common-gp/images/common/logo-modal-head.jpg" alt="LG Life\'s good"></div>'+comp9.innerHTML+''+divToPrint.innerHTML+'</div><script>setTimeout(function() { /msie|trident/i.test(navigator.userAgent) ? document.execCommand(\'print\', false, null) : window.print();}, 500);</script></body></html>');
				}else{
					newWin.document.write('<html dir='+ direction +'><body><style>.modal, .pdp-layer-tab, .pdp-specs-content, .tech-ctrl-area {display:none !important;}</style><link href="/lg5-common-gp/css/fonts.min.css" type="text/css" rel="stylesheet"><link href="/lg5-common-gp/css/default.min.css" type="text/css" rel="stylesheet"><link rel="stylesheet" href="/lg5-common-gp/css/components.min.css" type="text/css" /><link href="/lg5-common-gp/css/GPC0013.min.css" type="text/css" rel="stylesheet"><link rel="stylesheet" href="/lg5-common-gp/css/modal-print.min.css" type="text/css" /><div class="specs-print">'+divToPrint.innerHTML+'</div><script>/msie|trident/i.test(navigator.userAgent) ? document.execCommand(\'print\', false, null) : window.print();</script></body></html>');
				}
				/* LGEAU-618 end*/
				// 20200506 END
				// 20200401 END
				setTimeout(function() {
					//newWin.document.close();
					//setTimeout(function(){newWin.close();},10);
				}, 200);
			}else {
				window.print();
			}
		});
	};
	specRunPrint();

	//$obj.find('.tech-spacs-area').removeClass('show');

	// adobe
	$('body').on('click', '.GPC0013 .pdp-specs-content .pdp-specs-output .download-spec', function() {
		adobeTrackEvent('download_spec_sheet', {page_event : {download_spec_sheet : true}});
	});
	$('body').on('click', '.GPC0013 .pdp-specs-content .pdp-specs-output .download-guide', function() {
		adobeTrackEvent('download_energy_guide', {page_event : {download_energy_guide : true}});
	});

	// popover download manuals
	/*
	var manuals = {
		checker : true,
		activeClass : "active",
	}
	var activeEvent = function(tg){
		manuals.checker ? tg.addClass(manuals.activeClass) : tg.removeClass(manuals.activeClass);
	}
	// mouse
	$obj.find(".pdp-specs-output").on("mouseenter click", ".spec-menu", function(e){
		e.preventDefault();
		var $elem = $(this).siblings(".download-sets-wrap");
		manuals.checker = true;
		activeEvent($elem);
	});
	$obj.find(".download-sets-wrap").on("mouseleave", function(){
		var $elem = $(this);
		manuals.checker = false;
		activeEvent($elem);
	});
	$obj.find(".btn-dowload-set-close").on("click blur", function(e){
		e.preventDefault();
		var $elem = $(this).parent();
		manuals.checker = false;
		activeEvent($elem);
	});
	// keyboard
	$obj.find(".pdp-specs-output").on("keydown", ".spec-menu", function(e){
		var $elem = $(this).siblings(".download-sets-wrap");
		if(e.keyCode === 13){
			manuals.checker = true;
			activeEvent($elem);
		}
	});
	*/

	// file download
	var fileDownload = function($link) {
		if($('form#formDown').length>0) $('form#formDown').remove();

		var fileBox = $link.closest('[data-file-download]');
		var flag = fileBox.data('flag').toUpperCase();
		var downtime = fileBox.data('downtime') || null;
		var opentime = fileBox.data('opentime') || null;
		var latsUrl = $link.closest('[data-latsUrl]').data('latsurl') || null; //LGCOMMON-10774

		if(flag=='Y') {
			// downtime error
			var $errorPop = $('#htmlOpenError');
			if($errorPop.length>0) {
				$errorPop.modal();
				$errorPop.find('.htmldowntime').text(downtime);
				$errorPop.find('.htmlopentime').text(opentime);
			} else {
				console.log('#htmlOpenError is required in HTML');
			}
		} else if(latsUrl != null){
		    window.open(latsUrl, "_blank"); //LGCOMMON-10774
		} else {

			var doc = $link.data('doc'),
				file = $link.data('file'),
				original = $link.data('original'),
				category = $link.data('category');

			var input = '<input type="hidden" id="DOC_ID" name="DOC_ID" value="' + doc +'" />';
			input += '<input type="hidden" id="ORIGINAL_NAME_b1_a1" name="ORIGINAL_NAME_b1_a1" value="' + original +'" />';
			input += '<input type="hidden" id="FILE_NAME" name="FILE_NAME" value="' + file +'" />';
			input += '<input type="hidden" id="TC" name="TC" value="DwnCmd" />';
			input += '<input type="hidden" id="GSRI_DOC" name="GSRI_DOC" value="GSRI" />';
			input += '<input type="hidden" id="SPEC_DOWNLOAD" name="SPEC_DOWNLOAD" value="Y" />'; /*LGEGMC-1035 add*/
			
			var form = $('<form />').attr({
				id: 'formDown',
				method: 'get',
				action: fileBox.data('action'),
				target: '_self'
			}).append(input);
			$('body').append(form);

			$('#formDown').submit();
		}
	}
	$obj.find('.file-list a.link-text').on('click', function(e) {
		e.preventDefault();
		fileDownload($(this));
	});
	
	/* LGEIN-335 : 20210123 add */
	var $slick = function(){
		$obj.each(function(){
			var $objNext = $(this).find('.package-next');
			var $objPrev = $(this).find('.package-prev');
			$(this).find('.pdp-layer-tab-desktop-list .items').slick({
				listStyle: true, // WA-GPC0012-01
				autoplay: false,
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				dots: false,
				nextArrow:$objNext,
				prevArrow:$objPrev,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}, {
						breakpoint: 768,
						settings: {
							dots: true,
							arrows: false,
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});
		});
	};
	$slick();
	/*// LGEIN-335 : 20210123 add */
});
